import React, { useRef, useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  IconButton,
  Button,
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  Typography
} from "@mui/material";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Sidebar from "../../../Navigation/Sidebar/Sidebar";
import { useNavigate } from "react-router-dom";
import leftArrow from "../../../../assests/leftArrow.svg"
import unblock from "../../../../assests/unblock.svg"
import userunblockicon from "../../../../assests/userunblockedicon.svg"
import "./unblockPayout.css";

const PartnerBlockListComponent = ({
  partners,
  searchValue,
  setSearchValue,
  onBlock,
  onUnblock,
  onSelectPartner,
  selectedPartnerId,
  onLoadMore,
  hasMore,
  loading,
  onGoBack,
  openSuccessDialog,
  setOpenSuccessDialog
}) => {
  const navigate = useNavigate();
  const scrollContainerRef = useRef(null);
  const [selectedPartnerForUnblock, setSelectedPartnerForUnblock] = useState(null);
  const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const container = scrollContainerRef.current;
      if (container) {
        const { scrollTop, scrollHeight, clientHeight } = container;
        if (scrollHeight - scrollTop - clientHeight < 100 && hasMore && !loading) {
          onLoadMore();
        }
      }
    };

    const el = scrollContainerRef.current;
    if (el) {
      el.addEventListener('scroll', handleScroll);
      return () => el.removeEventListener('scroll', handleScroll);
    }
  }, [hasMore, loading, onLoadMore]);

  const handleUnblockClick = (partnerId, e) => {
    e.stopPropagation();
    setSelectedPartnerForUnblock(partnerId);
    setConfirmationDialogOpen(true);
  };

  const handleConfirmUnblock = () => {
    if (selectedPartnerForUnblock) {
      onUnblock(selectedPartnerForUnblock);
      setConfirmationDialogOpen(false);
      setSelectedPartnerForUnblock(null);
    }
  };

  const handleConfirmationDialogClose = () => {
    setConfirmationDialogOpen(false);
    setSelectedPartnerForUnblock(null);
  };

  const handleSuccessDialogClose = () => {
    setOpenSuccessDialog(false);
  };

  return (
    <div className="payoutpartner-layout">
      <Sidebar />
      <div className="payoutpartner-list-container">
        <div className="payoutpartner-list-header">
          <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-around" }}>
            <button
              className="payoutpartner-back-button"
              onClick={onGoBack}
              aria-label="Go back"
            >
              <img src={leftArrow} alt="" />
            </button>
            <h1 className="payoutpartner-title">Blocked Partners List</h1>
          </div>
        </div>

       
        <div style={{ padding: '16px', width: '330px' }}>
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Search by Owner ID or Cohort ID"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            InputProps={{
              style: { backgroundColor: 'white' }
            }}
          />
        </div>

        <TableContainer
          component={Paper}
          className="payoutpartner-table"
          ref={scrollContainerRef}
        >
          <Table stickyHeader>
            <TableHead style={{textAlign:"center"}}>
              <TableRow style={{textAlign:"center"}}>
                <TableCell>ID</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Description</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Cohort ID</TableCell>
                <TableCell>Owner ID</TableCell>
                <TableCell>Unblock</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading && partners&&partners.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    <CircularProgress size={24} />
                  </TableCell>
                </TableRow>
              ) : partners&&partners.length > 0 ? (
               partners&& partners.map((partner) => (
                  <TableRow
                    key={partner.id}
                    className={`payoutpartner-row ${selectedPartnerId === partner.id ? 'selected' : ''}`}
                    onClick={() => onSelectPartner(partner.id)}
                  >
                    <TableCell>{partner.id}</TableCell>
                    <TableCell>{partner.name}</TableCell>
                    <TableCell>{partner.description}</TableCell>
                    <TableCell>{partner.type}</TableCell>
                    <TableCell>{partner.cohortId}</TableCell>
                    <TableCell>{partner.ownerId}</TableCell>
                    <TableCell>
                      <IconButton
                        className="payoutview-icon"
                        size="small"
                        onClick={(e) => handleUnblockClick(partner.id, e)}
                      >
                        <img src={unblock} alt="Unblock" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={7} align="center" style={{ padding: '40px 0' }}>
                    <Typography variant="body1" color="textSecondary">
                      No blocked partners found
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Confirmation Dialog */}
        <Dialog
          open={confirmationDialogOpen}
          onClose={handleConfirmationDialogClose}
          maxWidth="xs"
          fullWidth
        >
          <DialogContent>
            <Box display="flex" flexDirection="column" alignItems="center" p={3}>
              <img src={userunblockicon} alt=""  style={{width:"70px", height:"70px", marginBottom:"10px"}}/>
              <Typography variant="h6" align="center" gutterBottom>
                Confirm Unblock
              </Typography>
              <Typography variant="body1" align="center" style={{ marginBottom: '20px' }}>
                Are you sure you want to unblock this partner? They will become eligible to receive payouts.
              </Typography>
              <Box display="flex" gap={2} justifyContent="center">
                <Button
                  variant="outlined"
                  onClick={handleConfirmationDialogClose}
                  style={{ minWidth: '100px' }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  color="success"
                  onClick={handleConfirmUnblock}
                  style={{ minWidth: '100px' }}
                >
                  OK
                </Button>
              </Box>
            </Box>
          </DialogContent>
        </Dialog>

        {/* Success Dialog */}
        <Dialog
          open={openSuccessDialog}
          onClose={handleSuccessDialogClose}
          maxWidth="xs"
          fullWidth
        >
          <DialogContent>
            <Box display="flex" flexDirection="column" alignItems="center" p={3}>
              <CheckCircleIcon color="success" sx={{ fontSize: 60, mb: 2 }} />
              <Typography variant="h6" align="center" gutterBottom>
                Successfully Unblocked
              </Typography>
              <Typography variant="body1" align="center" style={{ marginBottom: '20px' }}>
                Partner has been successfully unblocked and is now eligible to receive payouts.
              </Typography>
              <Button
                variant="contained"
                color="success"
                onClick={handleSuccessDialogClose}
                style={{ minWidth: '100px' }}
              >
                OK
              </Button>
            </Box>
          </DialogContent>
        </Dialog>
      </div>
    </div>
  );
};

export default PartnerBlockListComponent;